import { Link } from "react-router-dom";
import "./DoingsStyles.css";

function DoingsData(props) {
  const card = (
    <>
      {props.image && (
        <div className="t-image">
          <img src={props.image} alt={props.imageAlt || props.heading} />
        </div>
      )}
      <h4>{props.heading}</h4>
      <p>{props.text}</p>
    </>
  );

  // Cada cartão leva à secção correspondente da página de Serviços.
  if (props.link) {
    return (
      <Link className="t-card t-card-link" to={props.link}>
        {card}
      </Link>
    );
  }

  return <div className="t-card">{card}</div>;
}

export default DoingsData;
